import { complement, equals } from 'rambda';

export const notEquals = <T>(compareTo: T) => complement(equals(compareTo));
